var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReceiptOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4879 14.4947C20.3464 14.0944 20.1281 13.7304 19.8507 13.4204C19.2605 12.7611 18.403 12.3461 17.4485 12.3461H14.9539C13.365 12.3461 12.077 13.6341 12.077 15.2229C12.077 16.5749 13.0184 17.7444 14.3391 18.0333L18.1372 18.8642C19.6167 19.1878 20.6713 20.499 20.6713 22.0135C20.6713 23.7935 19.2284 25.2376 17.4485 25.2376H15.2999C13.8966 25.2376 12.7028 24.3407 12.2604 23.089",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3743 12.3457V9.12286",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3743 28.4602V25.2373",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0857 4.28857H9.12286C7.84073 4.28857 6.61111 4.7979 5.70451 5.70451C4.7979 6.61111 4.28857 7.84073 4.28857 9.12286V35.7114L10.3314 32.0857L16.3743 35.7114L22.4171 32.0857L28.46 35.7114V7.91429C28.46 6.9527 28.8419 6.03046 29.5219 5.35052C30.2018 4.67057 31.1242 4.28857 32.0857 4.28857ZM32.0857 4.28857C33.0473 4.28857 33.9696 4.67057 34.6496 5.35052C35.3295 6.03046 35.7114 6.9527 35.7114 7.91429V16.3743H28.46",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceiptOutline);
export default __webpack_public_path__ + "static/media/icon_receipt_outline.75285a635925ad75eb4dd7eba1ce72fb.svg";
export { ForwardRef as ReactComponent };